import { Icon } from "@octano/global-ui";
import clsx from "clsx";
import { useMemo } from "react";

interface DaysInformationProps {
  readonly numberDays: string | number;
  readonly subtitle: string;
  readonly active?: boolean;
  readonly information?: (props: undefined | any) => void;
  readonly floor?: boolean;
  readonly decimals?: boolean;
}

export const DaysInformation: React.FC<DaysInformationProps> = ({
  numberDays,
  subtitle,
  active = false,
  information,
  floor = false,
  decimals,
}) => {
  const title = useMemo(() => {
    const parsed =
      typeof numberDays === "number"
        ? numberDays
        : parseFloat(String(numberDays).replace(",", "."));

    if (!Number.isFinite(parsed)) {
      return numberDays;
    }

    const value = floor ? Math.floor(parsed) : parsed;

    if (decimals) {
      return value.toFixed(2).replace(".", ",");
    }

    return floor ? value : numberDays;
  }, [floor, numberDays, decimals]);
  return (
    <div
      className={clsx("days-information", {
        active: active,
      })}
    >
      <div className="days-information-container">
        {information ? (
          <i onClick={information} className="days-information-icon">
            <Icon name="information_input" color="inherit" />
          </i>
        ) : (
          ""
        )}
        <h4 className="days-information-title">{title}</h4>

        <h5 className="days-information-subtitle">{subtitle}</h5>
      </div>
    </div>
  );
};
